const debug = (...args) => {
  /* eslint-disable no-console */
  /* eslint-disable   no-undef */

  global.IS_LOCAL_OR_DEV && console.log.apply(this, args);
};

export default debug;
